import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import firebaseConfig from './FirebaseConfig';
import { getAuth } from '@firebase/auth';
import axios from 'axios';

const firebaseApp = initializeApp(firebaseConfig);
export const firestoreDb = getFirestore(firebaseApp);

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
export const BUSINESS_BASE_URL = process.env.REACT_APP_BUSINESS_BASE_URL || '';
export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || '';
export const PAYPLUS_DASHBOARD_URL =
  process.env.REACT_APP_PAYPLUS_DASHBOARD_URL || '';

export const firebaseAuth = getAuth(firebaseApp);
export const apiAxios = axios.create({
  baseURL: API_BASE_URL
});
